// extracted by mini-css-extract-plugin
export default {"cannedReplyEmpty":"cannedReplyEmpty__zfbq503aWpoY"};